import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/smartID/tekre_img_04.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={697}
              height={623}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>
              The <span style={{ color: "#2F55C4" }}>Solution</span>
            </h2>
            <p>
              Our creative approach to problem-solving is what truly sets us
              apart. When Maxim reached out to us for assistance, we saw this as
              an opportunity to let our inventive sides out and were happy to
              help bring his ideas to life. Our drive to help others by thinking
              outside of the box is the secret to our unparalleled innovation
              and design.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
